/**
 * InteractionPrompt - UI component that displays when player can interact with objects
 * Shows the interaction key and message (e.g., "Press E to open door")
 */

import React, { useEffect, useState } from 'react';
import './InteractionPrompt.css';

export interface InteractionPromptProps {
  message: string;
  key: string;
  visible: boolean;
}

export const InteractionPrompt: React.FC<InteractionPromptProps> = ({
  message,
  key: interactionKey,
  visible,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) {
      // Small delay for smooth fade-in
      const timer = setTimeout(() => setShow(true), 50);
      return () => clearTimeout(timer);
    } else {
      setShow(false);
    }
    return undefined;
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <div className={`interaction-prompt ${show ? 'show' : ''}`}>
      <div className="interaction-prompt-content">
        <span className="interaction-key">[{interactionKey}]</span>
        <span className="interaction-message">{message}</span>
      </div>
    </div>
  );
};

export default InteractionPrompt;
